export default 'data:image/svg+xml,' + encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24">'
  + '<rect width="24" height="24" rx="3" fill="#f0f2f5"/>'
  + '<path d="M20.59 13.41 13.42 20.58a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82Z" fill="none" stroke="#b4bdc7" stroke-width="1.6" stroke-linejoin="round"/>'
  + '<circle cx="7" cy="7" r="1.4" fill="#b4bdc7"/>'
  + '</svg>'
)
